import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import TrackContainer from "./TrackContainer";
import { selectRole, setLocation } from "./infoSlice";
import { selectEventsData, setEventData } from "../events/eventsSlice";
import { sendAnalyticsEvents } from "../../analytics/common";
import { EVENTS } from "../../analytics/events";

const LocationTrack = ({ history }) => {
  const { t } = useTranslation();
  const role = useSelector(selectRole)
  const dispatch = useDispatch();
  const eventsData = useSelector(selectEventsData);
  const locationOptions = useMemo(() => {
    const commonOption = {
      id: 0,
      imgPath: ('../assets/which_locations/home.png'),
      name: t("home"),
      value: 'Home'
    };
  
    let options = [];
  
    switch (role) {
      case 'Partner':
        options = [
          {
            id: 0,
            imgPath: ('../assets/which_locations/work.png'),
            name: t("work"),
            value: 'Work'
          },
          {
            id: 1,
            imgPath: ('../assets/which_locations/home.png'),
            name: t("home"),
            value: 'Home'
          },
          {
            id: 2,
            imgPath: ('../assets/which_locations/friends.png'),
            name: t("friends"),
            value: 'Friends'
          },
          {
            id: 3,
            imgPath: ('../assets/which_locations/bar_restaurant.png'),
            name: t("bar_restaurants"),
            value: 'Bars'
          },
          {
            id: 4,
            imgPath: ('../assets/which_locations/unknown_locations.png'),
            name: t("unknown_locations"),
            value: 'Unknown'
          },
        ];
        break;
      case 'Kid':
        options = [
          commonOption,
          {
            id: 1,
            imgPath: ('../assets/which_locations/school.png'),
            name: t("school"),
            value: 'School'
          },
          {
            id: 2,
            imgPath: ('../assets/which_locations/friends.png'),
            name: t("friends"),
            value: 'Friends'
          },
          {
            id: 3,
            imgPath: ('../assets/which_locations/hobby_classes.png'),
            name: t("hobby_classes"),
            value: 'Hobby'
          },
        ];
        break;
      case 'Friend':
      case 'Sibling':
        options = [
          commonOption,
          {
            id: 1,
            imgPath: ('../assets/which_locations/work.png'),
            name: t("work"),
            value: 'Work',
          },
          {
            id: 2,
            imgPath: ('../assets/which_locations/school.png'),
            name: t("school"),
            value: 'School'
          },
          {
            id: 3,
            imgPath: ('../assets/which_locations/bar_restaurant.png'),
            name: t("bar_restaurants"),
            value: 'Bars'
          },
        ];
        break;
      case 'Grandparent':
        options = [
          commonOption,
          {
            id: 1,
            imgPath: ('../assets/which_locations/work.png'),
            name: t("work"),
            value: 'Work',
          },
          {
            id: 2,
            imgPath: ('../assets/which_locations/medical_institution.png'),
            name: t("medical_institution"),
            value: 'Medical'
          },
        ];
        break;
      default:
        options = [
          commonOption,
          {
            id: 1,
            imgPath: ('../assets/which_locations/school.png'),
            name: t("school"),
            value: 'School'
          },
          {
            id: 2,
            imgPath: ('../assets/which_locations/friends.png'),
            name: t("friends"),
            value: 'Friends'
          },
          {
            id: 3,
            imgPath: ('../assets/which_locations/unknown_locations.png'),
            name: t("unknown_locations"),
            value: 'Unknown',
          },
        ];
        break;
    }
    const lastOption = {
      id: options.length + 1,
      imgPath: ('../assets/which_locations/other.png'),
      name: t("other"),
      value: 'Other'
    };
    options.push(lastOption);
  
    return options;
  }, [t, role]);

  const onContinueClick = (locations) => {
    dispatch(setEventData({ id: 'Locations', data: locations }))
    const locationList = locationOptions.reduce((arr, option, i) => {
      if (locations.includes(option.value)) {
        return [].concat(arr, [option.name]);
      }
      return arr;
    }, []);
    dispatch(setLocation(locationList));
    sendAnalyticsEvents(EVENTS.onboardingLocationsSubmitted, {
      ...eventsData,
      Locations: locations,
    })
    history.push('/choose-reason');
  };

  return (
    <TrackContainer
      pageEvent={"onboardingLocationsShown"}
      title={role === 'Other' ? t("question2_other") : t("question2_title", {role: role.toLowerCase()})}
      multiple
      options={locationOptions}
      onContinueClick={onContinueClick}
      nextPage={'choose-reason'}
  />
  )
}

export default LocationTrack;

